// External Imports
import { Fragment, useState } from "react";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";

// Internal Imports
import { isoDateToString } from "../../util/format-date";
import ListLabels from "../UI/ListLabels";
import Heading from "../UI/Heading";
import NoRecordsFound from "../UI/NoRecordsFound";

/** ========================================================================
 * * BookingExtensions Component
 * This component renders a list of extensions made on a booking.
 * ========================================================================== */

export default function BookingExtensions({ extensions = [] }) {
  // Initialize States
  const [show, setShow] = useState(false);

  // Sort extensions by date
  extensions = extensions.sort(
    (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
  );

  return (
    <div className="grid gap-2">
      <Heading
        title="Extensions"
        text="List of all extensions made to this booking."
        onClick={() => setShow(!show)}
        isBackArrow={false}
      >
        {show ? (
          <TbChevronUp className="icon" onClick={() => setShow(false)} />
        ) : (
          <TbChevronDown className="icon" onClick={() => setShow(true)} />
        )}
      </Heading>

      {show &&
        (extensions.length > 0 ? (
          <Fragment>
            <div className="labels lg:grid-cols-6">
              <ListLabels
                labels={[
                  "Date Created",
                  "Extended Till",
                  "Extended By",
                  "Miles Included",
                  "Taxes",
                  "Total Fees",
                ]}
              />
            </div>
            <div className="list max-h-[300px]">
              {extensions.map((extension) => (
                <div
                  key={extension.id}
                  className="grid text-sm cursor-auto pill lg:grid-cols-6 text-stone-200"
                >
                  <p className="text-stone-400">
                    {isoDateToString(extension.dateCreated)}
                  </p>
                  <p className="font-semibold">
                    {isoDateToString(extension.endDate) || "-"}
                  </p>
                  <p className="text-stone-400">
                    {extension.createdBy?.name || "-"}
                  </p>
                  <p className="text-stone-400">{extension.milesIncluded}mi</p>
                  <p className="text-stone-400">
                    ${extension.taxes?.toFixed(2) || "-"}
                  </p>
                  <p className="font-semibold">
                    ${extension.totalFees?.toFixed(2)}
                  </p>
                </div>
              ))}
            </div>
          </Fragment>
        ) : (
          <NoRecordsFound />
        ))}
    </div>
  );
}
